import { useEffect } from "react";

// Плавное появление секций при скролле.
// Цепляется ко всем section.mt на странице (баннеры без .mt не трогаем —
// у них свои анимации появления).
export default function useScrollReveal() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const sections = Array.from(document.querySelectorAll("section.mt"));
    if (!sections.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.05 }
    );

    sections.forEach((el) => {
      if (el.classList.contains("reveal-in")) return;
      el.classList.add("reveal-prep");
      io.observe(el);
    });

    return () => io.disconnect();
  }, []);
}
